
const CheckIcon = ({ fill='fill-tsecondary', width='13', height='11', className }) => {

    return (
        <svg width={width} height={height} className={className} viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path className={fill} fillRule="evenodd" clipRule="evenodd" d="M3.71502 9.65295L0.591483 6.50974C0.107018 6.01751 0.107018 5.22774 0.591483 4.73551C0.825232 4.50005 1.14333 4.36758 1.47513 4.36758C1.80694 4.36758 2.12504 4.50005 2.35879 4.73551L4.59816 6.98969L10.587 0.963394C10.8207 0.72793 11.1388 0.595459 11.4706 0.595459C11.8024 0.595459 12.1205 0.72793 12.3543 0.963394C12.8387 1.45562 12.8387 2.24539 12.3542 2.73762L5.4823 9.65295C5.24873 9.88877 4.93057 10.0214 4.59867 10.0214C4.26677 10.0214 3.94862 9.88877 3.71505 9.65295H3.71502Z"/>
        </svg>
    )

};

export default CheckIcon;




